
import React from 'react'
import { Info } from 'lucide-react'

interface ValidationErrorProps {
  error: string | null
}

const ValidationError = ({ error }: ValidationErrorProps) => {
  if (!error) return null
  
  return (
    <div className="mt-4 p-3 bg-amber-50 border border-amber-200 rounded-md flex items-start gap-2 text-amber-800">
      <Info className="h-5 w-5 mt-0.5 flex-shrink-0" />
      <div>
        <p className="font-medium">CSV Validation Error</p>
        <p className="text-sm">{error}</p>
      </div>
    </div>
  )
}

export default ValidationError
